import api from '@/api'

const Auth = {
    // namespaced: true,
    state: {
        auth: localStorage.getItem("Authkey") || '',
        authkey: ''
    },
    getters: {
        auth(state) {
            if (state.auth != null) {
                return state.auth;
            } else {
                return localStorage.getItem("Authkey");
            }
        },
        authkey(state) {
            if (state.authkey != null) {
                return state.authkey;
            } else {
                return localStorage.getItem("Authkey");
            }
        },
    },
    mutations: {
        saveAuthkey(state, data) {
            state.auth = data;
            localStorage.setItem("Authkey", data);
        },
        updateAuth(state, auth) {
            state.authkey = auth
            localStorage.setItem("Authkey", auth);
        },

    },
    actions: {
        // 更新用户认证
        updateAuth({
            commit
        }, auth) {
            commit('updateAuth', auth)
        },
        getAuthkey(context, data) {
            api.user.Getidentity()
                .then(res => {
                    if (!res.data) {
                        context.commit("saveAuthkey", 1);
                    } else {
                        context.commit("saveAuthkey", res.data.auditStatus);
                        context.commit('updateAuth', res.data.auditStatus);
                    }
                })
                .catch(res => {})
        },
    },
};
export default Auth;